<template>
  <div class="container-fluid">
    <v-card
      color="red"
      flat
      tile
      class="d-print-none"
    >
      <v-toolbar dense
                 src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg"
      >
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-card>
    <EmailsForm></EmailsForm>
  </div>
</template>

<script>
import EmailsForm from '@/components/forms/admin/EmailsForm'
export default {
  name: 'Emails',
  components: { EmailsForm }
}
</script>

<style scoped>

</style>
